import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import MainLayout from './components/MainLayout';
import { authService } from './services/authService';
import { tokenManager } from './services/tokenManager';
import { AdminResponse } from './types/auth';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [currentAdmin, setCurrentAdmin] = useState<AdminResponse | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const checkAuthentication = () => {
      const isAuth = authService.isAuthenticated();
      const storedAdmin = authService.getStoredAdmin();
      
      setIsAuthenticated(isAuth);
      setCurrentAdmin(storedAdmin);
      
      if (isAuth) {
        tokenManager.startTokenRefresh();
      }
      
      setIsLoading(false);
    };

    checkAuthentication();
    
    // Cleanup on unmount
    return () => {
      tokenManager.stopTokenRefresh();
    };
  }, []);

  const handleLogin = (admin: AdminResponse) => {
    setIsAuthenticated(true);
    setCurrentAdmin(admin);
    tokenManager.startTokenRefresh();
  };

  const handleLogout = () => {
    tokenManager.stopTokenRefresh();
    authService.logout();
    setIsAuthenticated(false);
    setCurrentAdmin(null);
  };

  if (isLoading) {
    return (
      <div className="App">
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          fontSize: '1.2rem'
        }}>
          Loading...
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route 
            path="/login" 
            element={
              isAuthenticated ? 
                <Navigate to="/" replace /> : 
                <Login onLogin={handleLogin} />
            } 
          />
          <Route 
            path="/*" 
            element={
              isAuthenticated ? 
                <MainLayout onLogout={handleLogout} currentAdmin={currentAdmin} /> : 
                <Navigate to="/login" replace />
            } 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
